exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-box {\n  overflow: auto;\n}\n.uu5-bricks-box-nesting-level-lower-than-inline {\n  min-height: 50px;\n  height: 100%;\n  padding: 8px;\n}\n.uu5-bricks-box-nesting-level-inline {\n  display: inline;\n  padding: 2px;\n}\n.uu5-bricks-box-click {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/box.less
// module id = 189
// module chunks = 0